"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceListEntryStruct = exports.DefaultProductPrices = exports.PriceStruct = void 0;
const superstruct_1 = require("superstruct");
const Timestamp_1 = require("../utils/Timestamp");
const curency_1 = require("./curency");
exports.PriceStruct = (0, superstruct_1.type)({
    netValue: (0, superstruct_1.number)(),
    serviceFee: (0, superstruct_1.number)(),
    amount: (0, superstruct_1.number)(),
    currency: curency_1.CurrencyStruct,
    unit: (0, superstruct_1.enums)(['notification', 'subscription']),
});
exports.PriceStruct.type = 'Price';
exports.DefaultProductPrices = {
    whatsapp: {
        netValue: 0.09,
        serviceFee: 0.01,
        amount: 0.1,
        currency: '€',
        unit: 'notification',
    },
    sms: {
        netValue: 0.09,
        serviceFee: 0.01,
        amount: 0.1,
        currency: '€',
        unit: 'notification',
    },
    private: {
        netValue: 0,
        serviceFee: 0,
        amount: 0,
        currency: '€',
        unit: 'subscription',
    },
    pro_monthly: {
        netValue: 0,
        serviceFee: 0,
        amount: 20,
        currency: '€',
        unit: 'subscription',
    },
    pro_annual: {
        netValue: 0,
        serviceFee: 0,
        amount: 212,
        currency: '€',
        unit: 'subscription',
    },
    enterprise_monthly: {
        netValue: 0,
        serviceFee: 0,
        amount: 50,
        currency: '€',
        unit: 'subscription',
    },
    enterprise_annual: {
        netValue: 0,
        serviceFee: 0,
        amount: 540,
        currency: '€',
        unit: 'subscription',
    },
};
exports.PriceListEntryStruct = (0, superstruct_1.type)({
    countryCode: (0, superstruct_1.string)(),
    timestamp: Timestamp_1.TimestampStruct,
    prices: (0, superstruct_1.record)((0, superstruct_1.string)(), exports.PriceStruct),
});
exports.PriceListEntryStruct.type = 'PriceListEntry';
//# sourceMappingURL=price.js.map